
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

//
import ResetButton from '@/components/buttons/ResetButton.vue';
import { isFilterActive } from '@/helpers/filter-helper';
import { OfferPresentationType, OfferPresentationTypes } from '@/interfaces/titles';
import { FilterCollection, FilterName } from '@/stores/filter.store';
import ToggleButton from '@/ui-components/ToggleButton.vue';
import { CollectionType } from '../../enums/collection-type';

// stores used
const Filter = namespace('filter');

@Component({
	name: 'FilterPresentationTypes',
	components: { ResetButton, ToggleButton },
})
export default class FilterPresentationTypes extends Vue {
	@Prop() collectionType: CollectionType;
	@Prop() currentFilters: FilterCollection;

	@Filter.Getter filters: (collectionType: CollectionType) => FilterCollection;

	@Filter.Action toggle: (payload: { filterName: FilterName; value: any; selectedState: 1 | 0 }) => void;

	get options() {
		// return only those presentation types which are actually a "quality"
		// @TODO unclear how to order the types, there’s no order/priority
		return OfferPresentationTypes.filter(presentationType => {
			return presentationType.isQuality;
		});
	}

	isFilterActive(filterName: FilterName, value: any) {
		return isFilterActive(filterName, value, this.filters(this.collectionType));
	}

	clicked(presentationType: OfferPresentationType) {
		const selectedState: 1 | 0 = this.isFilterActive('presentation_types', presentationType) ? 0 : 1;
		this.toggle({ filterName: 'presentation_types', value: presentationType, selectedState });
	}
}
